import IQueriesConfigState from "interfaces/queriesConfigState";
import {
  ISetFacilities,
  SET_INFINITE_SCROLL_MODE,
  SET_SELECTED_FACILITY_IDS
} from "../actions/queriesConfig";

const initialState: IQueriesConfigState = {
  selectedFacilityIds: [],
  isInfiniteScrollOn: true
};

export default (
  state: IQueriesConfigState = initialState,
  action: ISetFacilities
): IQueriesConfigState => {
  switch (action.type) {
    case SET_SELECTED_FACILITY_IDS: {
      return {
        ...state,
        selectedFacilityIds: [...action.selectedFacilityIds]
      };
    }
    case SET_INFINITE_SCROLL_MODE:
      return {
        ...state,
        isInfiniteScrollOn: action.isInfiniteScrollOn
      };
    default:
      return state;
  }
};
